// @flow

// Libs
import React from 'react'

// Styles
import { primary, grey } from 'fc-styles/src/colors'

// Components
import SortIcon from 'fc-icons/src/Sort'

// Types
type Props = {
  enabled?: boolean,
  size?: number,
}

// Exports
export default function AscIcon ({enabled, size = 16}: Props) {
  return (
    <SortIcon
      color={enabled ? primary() : grey()}
      size={size}
      style={{
        transform: 'rotateX(180deg)',
      }}
    />
  )
}
